import { Box, Stack, Typography } from "@mui/material";
import { ErrorLayout } from "./ErrorLayout";
import error404Img from "assets/images/error404.webp";
import { Button } from "components/button";
import { useNavigate } from "react-router-dom";

export const ErrorInvalidLink = () => {
  const navigate = useNavigate();
  return (
    <Box width={"100vw"} height={"calc(100% - 64px)"}>
      <ErrorLayout
        errorImg={error404Img}
        leftSide={
          <Stack
            sx={{
              maxWidth: "360px",
              gap: "16px",
            }}
          >
            <Typography variant="h3">
              Well, this is awkward... The page isn’t here anymore!
            </Typography>
            <Typography
              variant="body-large"
              sx={{
                textAlign: "justify",
              }}
            >
              Head back to where you started.
            </Typography>
            <Button
              fullWidth
              onClick={() => {
                navigate("/app/home");
              }}
            >
              Back to home
            </Button>
          </Stack>
        }
      />
    </Box>
  );
};
